import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Accordion": Accordion, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/Typography": Typography, "@mui/icons-material/ArrowDownward": ArrowDownwardIcon, "@mui/icons-material/ArrowDropDown": ArrowDropDownIcon } } });
export default ClientProvider;
